import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { AuthLayout } from './AuthLayout'

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.LemonApps.MafiaGo'

/** web_no_account: the web never creates players. Accounts are born on the phone. */
export function NoAccount() {
  const { t } = useTranslation()
  return (
    <AuthLayout>
      <div className="soc-card relative p-7">
        <span aria-hidden className="absolute inset-x-0 top-0 h-[3px] bg-brass" />
        <p className="soc-label text-brass">{t('noAccount.kicker')}</p>
        <h1 className="soc-title mt-2 text-[26px]">{t('noAccount.title')}</h1>
        <p className="soc-flavour mt-4 text-[17px]">{t('noAccount.flavour')}</p>
        <p className="mt-4 text-ink-soft">{t('noAccount.body')}</p>
        <ol className="mt-5 flex flex-col gap-2 text-[14px] text-ink-soft">
          {(['step1', 'step2', 'step3'] as const).map((k, i) => (
            <li key={k} className="flex gap-3">
              <span className="soc-num text-brass">{String(i + 1).padStart(2, '0')}</span>
              <span>{t(`noAccount.${k}`)}</span>
            </li>
          ))}
        </ol>
        <a className="soc-btn soc-btn-primary mt-6 w-full" href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
          {t('noAccount.download')}
        </a>
        <Link to="/login" className="soc-btn soc-btn-ghost mt-3 w-full">
          {t('nav.backToSignIn')}
        </Link>
      </div>
    </AuthLayout>
  )
}
